import { render, staticRenderFns } from "./FollowMenu.vue?vue&type=template&id=81d2c7a2&scoped=true"
import script from "./FollowMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FollowMenu.vue?vue&type=style&index=0&id=81d2c7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2c7a2",
  null
  
)

export default component.exports